// extracted by mini-css-extract-plugin
module.exports = {"Price":"Price_Price__rD6QA","Price__Montyly":"Price_Price__Montyly__2Jrui","Price__Emphasis":"Price_Price__Emphasis__2ZweY"};